/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues, change, reset } from 'redux-form'
import { Icon, Input, Button } from  'semantic-ui-react'
import { Collapse } from '@material-ui/core';

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { getVendors } from 'ducks/options'
import { SearchCont, InputCont, AdvanceCont } from './styled'

const SearchVendorList = (props) => {

  const {
    dispatch,
    formSearchName,
    fetchAPI,
    pageSize,
    vendors,
    placeholder = '',
    filterProductStatus = false,
    filterVendor = false,
  } = props

  const [visibleAS, setVisibleAS] = React.useState(false)

  React.useEffect(() => {
    dispatch(props.getVendors())
    dispatch(change(formSearchName, 'key', ''))
    dispatch(change(formSearchName, 'status', ''))
    dispatch(change(formSearchName, 'vendorCode', ''))
  }, [])

  function setVendors() {
    if(vendors.data) {
      return vendors.data.sort((a, b) => a.text ? a.text.localeCompare(b.text) : -1)
    }

    return []
  }

  function onResetClick(){
    dispatch(change(formSearchName, 'key', ''))
    dispatch(change(formSearchName, 'status', ''))
    dispatch(change(formSearchName, 'vendorCode', ''))
    fetchAPI({page:1, pageSize:pageSize})
  }

  function onAdvanceSearchClick(data){
    fetchAPI({...props.valueForm, ...data, page:1, pageSize:pageSize})
  }

  return (
    <SearchCont>
      <InputCont>
        <Field 
          name="key" 
          placeholder={placeholder} 
          onSearchClick={() => onAdvanceSearchClick()} 
          component={renderInputSearch} 
          onEnter={() => onAdvanceSearchClick()}
        /> 
        <Icon name='settings' circular inverted link onClick={() => setVisibleAS(!visibleAS)} />
      </InputCont>
      <Collapse in={visibleAS} timeout="auto" unmountOnExit>
        <AdvanceCont>
          {
            filterProductStatus &&
            <Field
              name='status'
              label='Status'
              allowAdditions={false}
              options={
                [
                  {key: 'all', value: '', text: 'All Status'},
                  {key: 'published', value: 'Published', text: 'Published'},
                  {key: 'archived', value: 'Archived', text: 'Archived'},
                ]
              }
              specialOnChange={(value) => {
                onAdvanceSearchClick({status: value})
              }}
              type={type.select}
              component={FieldInput}
            />
          }

          {
            filterVendor &&
            <Field
              name='vendorCode'
              label='Vendor'
              allowAdditions={false}
              loading={vendors.loading}
              options={
                [
                  {key: 'a', value: '', text: 'All Vendor'},
                  ...setVendors()
                ]
              }
              specialOnChange={(value) => {
                onAdvanceSearchClick({vendorCode: value})
              }}
              type={type.select}
              component={FieldInput}
            />
          }

          <Button type='button' style={{marginLeft:'1rem',marginTop:'1.37rem'}} onClick={()=>{dispatch(reset(props.formSearchName));onResetClick()}}>Clear</Button>
        </AdvanceCont>
      </Collapse>
    </SearchCont>
  )

}

const renderInputSearch = props => {
  const {input,onSearchClick,placeholder} = props
  return (
    <Input 
    {...input}
    onKeyDown={(e)=>{
      if (e.key === 'Enter') {
        props.onEnter()
      }
    }}
    className='searchInput' 
    icon={<Icon type='button' name='search' inverted circular link onClick={onSearchClick}/>} 
    placeholder={placeholder} />
  )
}

const mapStateToProps = (state,props) => {
  return ({
    valueForm: getFormValues(props.formSearchName)(state),
    vendors: state.options.vendors,
  })
}

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  getVendors,
})

export default connect(mapStateToProps, mapDispatchToProps)(SearchVendorList)
